import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteNotificationParams {
  notificationId: string;
}

export interface DeleteNotificationResponse {
  success: boolean;
  data: { id: string; deleted: boolean };
}

const deleteNotification: MutationFunction<
  boolean,
  DeleteNotificationParams
> = async (args) => {
  if (isMockServices()) return (await mock(_mockType)).success;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteNotificationResponse>(
    `/users/me/notifications/${args.notificationId}`,
    {
      method: 'DELETE',
    },
  );
  if (response.success) return response.success;

  throw new Error('Failed to delete notification');
};

export default deleteNotification;

const _mockType = {
  success: true,
};
